import { render } from "./RichMenuSettingForm.vue?vue&type=template&id=73b6f620&scoped=true"
import script from "./RichMenuSettingForm.vue?vue&type=script&lang=ts"
export * from "./RichMenuSettingForm.vue?vue&type=script&lang=ts"

import "./RichMenuSettingForm.vue?vue&type=style&index=0&id=73b6f620&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-73b6f620"

export default script
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QIcon,QSpace,QBtn});
